import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UserAvatar from '@/components/UserAvatar';
import {useGetOneUser, useGetOneUserForHistory} from '@/modules/admin/hooks/useUser';

const RenderUser = ({ user, className, textClassName, showAvatar = true, textHeader, ...rest }) => {
  return (
    <div className={classNames(className, 'flex flex-row items-center')}>
      {showAvatar && <UserAvatar user={user} {...rest}/>}
      <div>
        {textHeader && <span className={classNames(textClassName, 'ml-2 opacity-75 block')}>{textHeader}</span>}
        <span className={classNames(textClassName, 'ml-2 block')}>{user?.fullName}</span>
      </div>
    </div>
  );
};

// Split hooks into separate components to respect Rules of Hooks
const UserFromServerDefault = ({ id, ...rest }) => {
  const { isLoading, data } = useGetOneUser({ id });
  if (!data || isLoading) return <Fragment/>;
  return <RenderUser user={data.data} {...rest}/>;
};

const UserFromServerHistory = ({ id, ...rest }) => {
  // useGetOneUserForHistory expects an object with id
  const { isLoading, data } = useGetOneUserForHistory({ id });
  if (!data || isLoading) return <Fragment/>;
  return <RenderUser user={data} {...rest}/>;
};

const UserFromServer = ({ id, fromHistory,  ...rest }) => {
  return fromHistory
    ? <UserFromServerHistory id={id} {...rest}/>
    : <UserFromServerDefault id={id} {...rest}/>;
};

const User = ({ user, ...rest }) => {
  if (!user) return <Fragment/>;
  if (typeof user === 'string') return <UserFromServer id={user} {...rest}/>;
  return <RenderUser user={user} {...rest}/>;
};

export default memo(User);

UserFromServer.propTypes = {
  id: PropTypes.string,
  fromHistory: PropTypes.bool
};

UserFromServerDefault.propTypes = {
  id: PropTypes.string,
  fromHistory: PropTypes.bool
};

UserFromServerHistory.propTypes = {
  id: PropTypes.string,
  fromHistory: PropTypes.bool
};

RenderUser.propTypes = {
  className: PropTypes.string,
  showAvatar: PropTypes.bool,
  textClassName: PropTypes.string,
  user: PropTypes.object,
  textHeader: PropTypes.string,
  fromHistory: PropTypes.bool
};

User.propTypes = {
  className: PropTypes.string,
  textClassName: PropTypes.string,
  user: PropTypes.object,
  textHeader: PropTypes.string,
};

export const renderUser = (user, textHeader) => {
  return (<User user={user} textHeader={textHeader}/>);
};
